import { ComponentType } from 'react'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { ClockIcon, DropTrailerIcon } from 'transfix-icons'

export const getLoadingMethodText = (isDropTrailer: boolean): string =>
  isDropTrailer ? 'Drop Trailer' : 'Live Load'

export const getLoadingMethodIconComponent = (
  isDropTrailer: boolean
): ComponentType<ICommonProps> => {
  return isDropTrailer ? DropTrailerIcon : ClockIcon
}

export type LoadingMethod = 'liveLoad' | 'dropTrailer' // TODO - move to constants

export const LOADING_METHOD_OPTIONS = [
  {
    label: 'Live Load',
    value: 'liveLoad',
  },
  {
    label: 'Drop Trailer',
    value: 'dropTrailer',
  },
]

export const loadingMethodValue = (isDropTrailer: boolean): LoadingMethod =>
  isDropTrailer ? 'dropTrailer' : 'liveLoad'
